import {  Mail, MessageCircle, Phone, Sparkles } from "lucide-react";
import { ChannelType } from "../../../crm-pages/activities/types";

export const ChannelIcon: React.FC<{ channel: ChannelType }> = ({ channel }) => {
  const iconMap = {
    email: <Mail className="w-4 h-4" />,
    whatsapp: <MessageCircle className="w-4 h-4" />,
    call: <Phone className="w-4 h-4" />,
    'ai-call': <Sparkles className="w-4 h-4" />,
    'web-chat': <MessageCircle className="w-4 h-4" />
  };

  const bgMap = {
    email: 'bg-purple-100',
    whatsapp: 'bg-green-100',
    call: 'bg-orange-100',
    'ai-call': 'bg-blue-100',
    'web-chat': 'bg-cyan-100'
  };

  const textMap = {
    email: 'text-purple-600',
    whatsapp: 'text-green-600',
    call: 'text-orange-600',
    'ai-call': 'text-blue-600',
    'web-chat': 'text-cyan-600'
  };

  return (
    <div className={`w-10 h-10 rounded-full ${bgMap[channel]} ${textMap[channel]} flex items-center justify-center flex-shrink-0`}>
      {iconMap[channel]}
    </div>
  );
};

export const ChannelBadge: React.FC<{ channel: ChannelType }> = ({ channel }) => {
  const labelMap = {
    email: 'Email',
    whatsapp: 'WhatsApp',
    call: 'Phone Call',
    'ai-call': 'AI Call',
    'web-chat': 'Web Chat'
  };

  const colorMap = {
    email: 'bg-purple-50 text-purple-700 border-purple-200',
    whatsapp: 'bg-green-50 text-green-700 border-green-200',
    call: 'bg-orange-50 text-orange-700 border-orange-200',
    'ai-call': 'bg-blue-50 text-blue-700 border-blue-200',
    'web-chat': 'bg-cyan-50 text-cyan-700 border-cyan-200'
  };

  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium border ${colorMap[channel]}`}>
      {labelMap[channel]}
    </span>
  );
};
